<template>
  <div class="page-container animate-fade-in">
    <PageHeader
      title="Messages"
      description="Contact form submissions from your portfolio."
      :breadcrumbs="[{ label: 'Admin', to: '/admin' }, { label: 'Messages' }]"
    />

    <BaseCard :padding="false" class="overflow-hidden">
      <div v-if="loading" class="p-8 text-center text-muted">Loading messages...</div>
      <div v-else-if="!messages.length" class="p-8 text-center text-muted">No messages yet.</div>
      <div v-else class="divide-y divide-border-subtle">
        <div v-for="message in messages" :key="message.id" class="p-6 hover:bg-border-subtle/20 transition-colors">
          <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-3">
            <div>
              <p class="font-semibold text-foreground">{{ message.name }}</p>
              <a :href="`mailto:${message.email}`" class="text-sm text-primary hover:underline">{{ message.email }}</a>
            </div>
            <BaseBadge variant="default" size="sm">{{ message.date || 'No date' }}</BaseBadge>
          </div>
          <p class="text-sm font-medium text-foreground">{{ message.subject }}</p>
          <p class="text-sm text-muted mt-2 whitespace-pre-wrap">{{ message.message }}</p>
        </div>
      </div>
    </BaseCard>
  </div>
</template>

<script>
import { firebase } from '@/api/firebase'
import PageHeader from '@/components/layout/PageHeader.vue'
import BaseCard from '@/components/ui/BaseCard.vue'
import BaseBadge from '@/components/ui/BaseBadge.vue'

export default {
  name: 'AdminMessages',
  components: { PageHeader, BaseCard, BaseBadge },
  data() {
    return {
      loading: true,
      messages: [],
    }
  },
  async created() {
    await this.loadMessages()
  },
  methods: {
    async loadMessages() {
      this.loading = true
      try {
        const items = (await firebase.getObjects('messages')) || []
        this.messages = items
          .map((item, index) => ({ id: item.id || index, ...item }))
          .sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')))
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
